"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTankWaterHealthData = void 0;
const getTankWaterHealthData = (fillPercentage) => {
    let water_availability = 'E';
    let water_availability_message = 'Data error under investigation';
    switch (true) {
        case fillPercentage >= 75 && fillPercentage <= 100:
            water_availability_message = 'Conserve Water';
            water_availability = 'A';
            return { water_availability, water_availability_message };
        case fillPercentage >= 50 && fillPercentage <= 74:
            water_availability_message = 'Ration water use';
            water_availability = 'B';
            return { water_availability, water_availability_message };
        case fillPercentage >= 25 && fillPercentage <= 49:
            water_availability = 'C';
            water_availability_message = 'Red alert. Control water use';
            return { water_availability, water_availability_message };
        case fillPercentage <= 24:
            water_availability = 'D';
            water_availability_message = 'Only use for drinking';
            return { water_availability, water_availability_message };
        default:
            return { water_availability, water_availability_message };
    }
};
exports.getTankWaterHealthData = getTankWaterHealthData;
